/**
 * Venue facts shown on more than one site. GOOGLE_RATING_LINE must stay byte-identical to the
 * literal in client-lamirage-in/src/pages/BookingPage.tsx (pinned there by maisonPages.test.ts);
 * a test asserts BookingPage still contains it, so the copies cannot drift.
 */
export const GOOGLE_RATING_LINE = "★ 4.5 · 1,220 Google reviews";
export const EVENTS_LINE = "1000+ events since 2022";

/**
 * Owner-confirmed 2026-11-02 (SEO plan 2026-11-01 §3.0, F11): drive time from Cochin International
 * Airport (COK). Shared because both la-mirage.in (catalogue.ts re-exports it) and the WhatsApp bot
 * quote it — they used to disagree (25 vs 45 min).
 */
export const AIRPORT_DRIVE_MINUTES = 25;
/**
 * Owner-confirmed 2026-11-02 (F1): the largest event the venue states publicly — "events for up to
 * 1,500 guests". HOW (sittings, indoor + garden split) was NOT confirmed: never state it.
 */
export const MAX_EVENT_GUESTS = 1500;
/** "1,500" — the en-IN text la-mirage.in prints. Bots/prompts use this so customers see one spelling. */
export const MAX_EVENT_GUESTS_TEXT = MAX_EVENT_GUESTS.toLocaleString("en-IN");

/** LA Mirage Koratty's Google Maps place (owner 2026-10-20). The location QR codes encode exactly this URL. */
export const GOOGLE_MAPS_PLACE_URL = "https://www.google.com/maps?cid=1469654264509270844";
/** QR images served by la-mirage.in (client-lamirage-in/public). The PNG is for WhatsApp (no SVG there). */
export const LOCATION_QR_SVG_PATH = "/assets/location/maps-qr.svg";
export const LOCATION_QR_PNG_URL = "https://la-mirage.in/assets/location/maps-qr.png";

/**
 * The ONE venue entity (SEO plan 2026-11-01 AD.6 #4 / onsite.md O13). la-mirage.in's home
 * `EventVenue` owns it; the lamirage.co / lamirage.live shell (`client/index.html`) references the
 * same `@id` and `url` instead of declaring a second venue. Pinned by shared/__tests__/venueEntity.test.ts.
 */
export const VENUE_URL = "https://la-mirage.in/";
export const VENUE_ENTITY_ID = "https://la-mirage.in/#venue";
/** One spelling everywhere in schema. Owner fact F12 (literal signage name) may change it — change it HERE. */
export const VENUE_ALTERNATE_NAME = "LA Mirage Convention Centre";
/**
 * Profiles of the same venue. Never a page of la-mirage.in itself (not a valid sameAs, PLAN CA7).
 * The social URLs are copies of client-lamirage-in/src/data/site.ts SOCIALS (the test pins them).
 */
export const VENUE_SAME_AS: readonly string[] = [
  GOOGLE_MAPS_PLACE_URL,
  "https://lamirage.co/",
  "https://www.youtube.com/@lamiragekoratty",
  "https://www.instagram.com/lamirageindia",
  "https://www.facebook.com/Lamiragekoratty",
];
